// extracted by mini-css-extract-plugin
export var label = "_e0-5";
export var slideContainer = "_e0-0";
export var slider = "_e0-1";
export var sliderLg = "_e0-4";
export var sliderMd = "_e0-3";
export var sliderSm = "_e0-2";